var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6639B7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13571",
    className: "cls-1",
    d: "M12,0C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12h0C24,5.37,18.63,0,12,0M14.02,19.41c0,.45-.37.82-.82.82h-2.39c-.45,0-.82-.37-.82-.82v-9.35c0-.45.37-.82.82-.82h2.39c.45,0,.82.37.82.82v9.35ZM14.02,5.63c0,1.12-.92,2.02-2.03,2.01-1.07,0-1.95-.84-2.01-1.91v-.15c-.06-1.11.79-2.07,1.91-2.13,1.11-.06,2.07.79,2.13,1.91,0,.04,0,.08,0,.12v.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon_information.f09326795e05aec89cebfe750b0b7c09.svg";
export { ForwardRef as ReactComponent };